import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { stripTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream-beige border-y border-gold-light" data-id="element-280" data-mp="3sq1wvzm5442a">
      <div className="max-w-7xl mx-auto px-4" data-id="element-281" data-mp="3ss4vh81cz5im">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-282" data-mp="3nyk624dtzjv1">
          {stripTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-cream-card border border-gold-light p-6 rounded-2xl shadow-sm" data-id="element-283" data-mp="5kau5adfwcyo" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-284" data-mp="2hava2fyo63eo">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" data-id="element-285" data-mp="ccpj9v0rl7ev" data-mpi={star} />)}
              </div>
              <blockquote className="text-ink italic mb-6 text-sm leading-relaxed" data-id="element-286" data-mp="ge18w0jn1sn2">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-3" data-id="element-287" data-mp="lc2rkkd5jpy0">
                <div className="w-10 h-10 rounded-full bg-navy-deep border border-gold flex items-center justify-center text-gold-light font-bold" data-id="element-288" data-mp="q4dvdyb0jvvu">
                  {testimonial.initials}
                </div>
                <div data-id="element-289" data-mp="100yy2czk8uwi">
                  <div className="font-bold text-navy-deep text-sm" data-id="element-290" data-mp="100guevakjeek">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-navy-mid" data-id="element-291" data-mp="192zreyroawsw">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}